import { gql } from 'graphql-request';
export const GitBranchesTabQuery = gql `
  query GitBranchesTab(
    $projectUid: String!
    $scope: LocalCheckoutScope
    $offset: Int
    $limit: Int
    $includeSizeOnDisk: Boolean
    $unusedAfterDays: Int
  ) {
    localGitCheckouts(
      projectUid: $projectUid
      scope: $scope
      offset: $offset
      limit: $limit
      includeSizeOnDisk: $includeSizeOnDisk
      unusedAfterDays: $unusedAfterDays
    ) {
      totalCount
      unusedCount
      unusedAfterDays
      checkouts {
        userRepositoryUid
        branch
        isMainBranch
        isActive
        isDeletable
        notDeletableReason
        user {
          uid
          name
          email
        }
        detail {
          lastCommitAuthor
          lastCommittedAt
          warning
          warningText
          uncommittedFileCount
          uncommittedFiles
          sharedWithOtherUsers
          sizeOnDiskBytes
          error
        }
      }
    }
  }
`;
export const DeleteGitBranchesMutation = gql `
  mutation DeleteGitBranches($userRepositoryUids: [String!]!, $scope: LocalCheckoutScope) {
    deleteLocalGitCheckouts(userRepositoryUids: $userRepositoryUids, scope: $scope) {
      requested
      deleted
      skipped
      results {
        userRepositoryUid
        branch
        deleted
        reason
      }
    }
  }
`;
